import { ReactNode } from "react";

/** Static (non-animated) shiny silk fill — shared by bento grid & social cards. */
export default function SilkCover({
  base,
  grid,
  className,
  children,
}: {
  base: string;
  grid?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div
      aria-hidden={children ? undefined : true}
      className={`relative overflow-hidden ${className ?? ""}`}
      style={{
        backgroundColor: base,
        backgroundImage: [
          "radial-gradient(115% 90% at 18% 14%, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 55%)",
          "radial-gradient(95% 80% at 86% 20%, rgba(255,255,255,0.24) 0%, rgba(255,255,255,0) 60%)",
          "radial-gradient(85% 85% at 74% 94%, rgba(0,0,0,0.20) 0%, rgba(0,0,0,0) 60%)",
          "radial-gradient(70% 65% at 26% 80%, rgba(0,0,0,0.12) 0%, rgba(0,0,0,0) 55%)",
          "linear-gradient(125deg, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0) 34%, rgba(0,0,0,0.05) 68%, rgba(255,255,255,0.12) 100%)",
        ].join(", "),
      }}
    >
      {grid ? (
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(31,61,59,0.55) 1px, transparent 1px)," +
              "linear-gradient(to bottom, rgba(31,61,59,0.55) 1px, transparent 1px)",
            backgroundSize: "26px 26px",
            WebkitMaskImage:
              "radial-gradient(95% 95% at 100% 0%, #000 0%, rgba(0,0,0,0.4) 38%, transparent 66%)",
            maskImage:
              "radial-gradient(95% 95% at 100% 0%, #000 0%, rgba(0,0,0,0.4) 38%, transparent 66%)",
          }}
        />
      ) : null}
      {children}
    </div>
  );
}
